module.exports = __webpack_public_path__ + "images/cv_bulk_btn02_87dbc8637de7ce2a60f2f42bc893229d.png";